import React, { useState } from 'react';

function Header({ isScrolled, isDarkMode, toggleTheme }) {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
            <div className="header-container">
                <div className="logo">
                    <a href="#home">
                        <h1>Xarel·lo</h1>
                    </a>
                </div>
                <button 
                    className={`mobile-menu-button ${isMenuOpen ? 'open' : ''}`}
                    onClick={toggleMenu}
                    aria-label="Toggle menu"
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
                <nav className={`navigation ${isMenuOpen ? 'open' : ''}`}>
                    <ul>
                        <li><a href="#home" onClick={() => setIsMenuOpen(false)}>Inici</a></li>
                        <li><a href="#menu" onClick={() => setIsMenuOpen(false)}>Carta</a></li>
                        <li><a href="#contact" onClick={() => setIsMenuOpen(false)}>Contacte</a></li>
                        <li>
                            <button 
                                className="theme-toggle" 
                                onClick={toggleTheme}
                                aria-label="Toggle theme"
                            >
                                {isDarkMode ? '🌙' : '☀️'}
                            </button>
                        </li>
                    </ul>
                </nav>
            </div>
        </header>
    );
}

export default Header;